export default "__VITE_ASSET__C$Lp69Os__"